import React from 'react'
import DodoneEditModal from 'app/dodones/edit/Modal'
import DodoneStats from 'app/dodones/shared/Stats'

export default ({ dodone }) => {
  return (
    <>
      <DodoneStats dodone={ dodone } />
      <DodoneEditModal attributeName="comment">
        <div className="darkest-gray-transparent-box rounded px-d py-2">
          <div className="text-xs text-gray-400">Comment </div>
          { dodone.comment ? dodone.comment : <div className="italic">empty</div> }
        </div>
      </DodoneEditModal>
    </>
  )
};
